import icons from "./components/icons";


export type Application = {
    name: string
    iconName?: keyof typeof icons
    badge?: "new" | "soon"
    disabled?: boolean
} & ({
    type: "internal"
    id: string
} | {
    type: "external"
    uri: string
})


const APPS: Application[] = [
    {
        name: "Финансы",
        type: "internal",
        id: "finance",
        iconName: "finance",
    },
    {
        name: "Автовизиты",
        type: "internal",
        id: "auto-visits",
        iconName: "autoVisit",
    },
    {
        name: "Заявки на пропуск",
        type: "internal",
        id: "passes",
        iconName: "passes",
    },
    {
        name: "Грузы в порту",
        type: "internal",
        id: "cargos",
        iconName: "cargoHistory",
    },
    {
        name: "Закрытие склада",
        type: "internal",
        id: "warehouse-closure",
        iconName: "warehouse",
    },
    // {
    //      name: "Наряды на авто",
    //      id: "auto-shipment-orders",
    //      type: "internal",
    //      // disabled: true,
    //      iconName: "jobOffers",
    //      // badge: "soon",
    // },
    {
        name: "Подход флота",
        type: "internal",
        id: "vessel-calls",
        iconName: "vesselCals"
    },
    {
        name: "Таможенные требования",
        type: "internal",
        id: "customs-requirements",
        iconName: "customsRequirements",
    },
    // {
    //     name: "Доверенности",
    //     id: "proxy",
    //     type: "internal",
    //     disabled: true,
    //     iconName: "proxy",
    //     badge: "soon",
    // },
    // {
    //     name: "Акты",
    //     type: "internal",
    //     id: "acts",
    //     disabled: true,
    //     iconName: "acts",
    //     badge: "soon",
    // },

]


export const useApps = () => {
    const data = APPS.map(app => {
        return {
            ...app,
            disabled: app.badge == "soon",
        };
    });

    return {
        loading: false,
        data
    }
}
